import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { resourceCategories, resourceItems } from '@/mocks/content';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function ResourcesSection() {
  const [active, setActive] = useState('all');
  const list = active === 'all' ? resourceItems : resourceItems.filter((item) => item.category === active);

  return (
    <section id="resources" className="scroll-mt-16 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <Reveal>
            <SectionHeading
              eyebrow="Resources"
              title="阅读资源类型一览"
              desc="围绕《漂亮的保姆》整理出的资源按小说文本、漫画资源与格式说明三个方向划分。点击下方标签即可筛选查看，所有内容均在本页呈现。"
            />
          </Reveal>

          <Reveal delay={60}>
            <div className="flex flex-wrap gap-1 p-1 rounded-full bg-background-100 border border-background-200">
              {resourceCategories.map((cat) => (
                <button
                  key={cat.key}
                  type="button"
                  onClick={() => setActive(cat.key)}
                  className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    active === cat.key
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-primary-700'
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {list.map((item, index) => (
            <Reveal key={item.id} delay={index * 50}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 flex flex-col gap-4">
                <div className="flex items-start gap-4">
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-2xl shrink-0">
                    <i className={item.icon} />
                  </span>
                  <div className="flex-1">
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900">
                      {item.title}
                    </h3>
                    <span className="mt-1 inline-flex items-center gap-1 text-xs text-secondary-800">
                      <i className="ri-price-tag-3-line" />
                      {item.format}
                    </span>
                  </div>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <div className="flex flex-wrap gap-2 mt-auto pt-1">
                  {item.points.map((point) => (
                    <span
                      key={point}
                      className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs"
                    >
                      <i className="ri-check-line" />
                      {point}
                    </span>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}